import type { QuoteSetupPresetSearchRequestQuery } from '@lio/api-types';

export const quoteSetupPresetQueryKey = {
  resource: 'quoteSetupPreset' as const,
  get: (resourceId?: string) => [quoteSetupPresetQueryKey.resource, resourceId] as const,
  searchWithParams: (params?: QuoteSetupPresetSearchRequestQuery) =>
    [...quoteSetupPresetQueryKey.get(), params] as const,
};
